import {keyBy, omit} from 'es-toolkit'

import {CoreState} from '../redux/features/core'

import {Material, Permission, ProviderId} from '../types'

import * as carrierApi from './api/carrier'
import * as colorApi from './api/color'
import * as countryApi from './api/country'
import * as finishGroupApi from './api/finish-group'
import * as materialApi from './api/material'
import * as materialConfigApi from './api/material-config'
import * as materialGroupApi from './api/material-group'
import * as printingMethodApi from './api/printing-method'
import * as providerApi from './api/provider'

const initData = async (
  permission: Permission,
  providerId: ProviderId
): Promise<Partial<CoreState>> => {
  const [
    materialConfigs,
    colors,
    finishGroups,
    materials,
    materialGroups,
    provider,
    countries,
    printingMethods,
    carriers,
  ] = await Promise.all([
    materialConfigApi.getByDefaultOrder(),
    colorApi.get(),
    finishGroupApi.getByDefaultOrderWithTags(),
    materialApi.getByDefaultOrderWithTagsAndPrintingMethodsAndAppIds(),
    materialGroupApi.get(permission),
    providerApi.getById(providerId),
    countryApi.get(),
    printingMethodApi.get(),
    carrierApi.get(),
  ])

  // Verification: only use materials which have at least one finishGroup
  const filteredMaterials: Material[] = materials
    .filter(material => finishGroups.find(finishGroup => finishGroup.materialId === material.id))
    // We need ot fetch the materials with modifier "includeProviders" to get the maximumPrintingDimenions, but we don't need the providers at all
    .map(material => omit(material as Material & {providers?: unknown}, ['providers'])) // omit providers to reduce memory usage

  return {
    materialConfigs: keyBy(materialConfigs, materialConfig => materialConfig.id),
    colors: keyBy(colors, color => color.id),
    finishGroups: keyBy(finishGroups, finishGroup => finishGroup.id),
    materials: keyBy(filteredMaterials, material => material.id),
    materialGroups: keyBy(materialGroups, materialGroup => materialGroup.id),
    provider,
    countries: keyBy(countries, country => country.code),
    printingMethods: keyBy(printingMethods, printingMethod => printingMethod.id),
    carriers: keyBy(carriers, carrier => carrier.id),
  }
}

export default initData
